module.exports = __webpack_public_path__ + "static/media/project-page.c1623ee4.png";